module.exports = __webpack_public_path__ + "img/aftaa_yes.6c700208.png";